import React from 'react';
import { Box, Typography, GridLegacy as Grid, Card, CardMedia } from '@mui/material';

const GiftHeader: React.FC = () => {

  const imgs: string[] = [
    'https://storage.googleapis.com/lcp_api_media/website/LGCYCard_graphics_web1.jpg',
    'https://storage.googleapis.com/lcp_api_media/website/LGCYCard_graphics_web2.jpg',
    'https://storage.googleapis.com/lcp_api_media/website/LGCYCard_graphics_web3.jpg',
    'https://storage.googleapis.com/lcp_api_media/website/LGCYCard_graphics_web4.jpg',
    'https://storage.googleapis.com/lcp_api_media/website/LGCYCard_graphics_web5.jpg',
    'https://storage.googleapis.com/lcp_api_media/website/LGCYCard_graphics_web6.jpg',
  ];

  return (
    <Box>
      <Box 
        sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          mb: 3, 
        }}
      >
        <img src="/logo.png" alt="LGCY Logo" style={{ width: 180, height: 90 }} />
      </Box>
      <Typography 
        variant="h4" 
        component="h1" 
        sx={{ 
          fontWeight: 'bold', 
          color: 'text.primary', 
          mb: 2,
          fontSize: { xs: '1.75rem', md: '2.25rem' },
          mx: 'auto',
          width: 'fit-content',
        }}
      >
        Gift A LGCY
      </Typography>
      <Typography 
        variant="body1"
        textAlign="center"
        sx={{ 
          color: 'text.secondary', 
          fontSize: '1.125rem', 
          maxWidth: '42rem', 
          mx: 'auto',
          mb: 4,
        }}
      >
        Give a friend or family member the gift of remembrance, an easy way to honor the life, love and legacy of their cherished companion.
      </Typography>

      <Grid container spacing={2} sx={{ mt: 2, mb: 4 }}>
        {imgs.map((publicUrl, index) => (
          <Grid item xs={2} sm={2} key={index}>
            <Card sx={{ 
              borderRadius: '8px', 
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              overflow: 'hidden',
            }}>
              <CardMedia
                component="img"
                image={publicUrl}
                alt={`LGCY Card sample ${index + 1}`}
                sx={{ width: '100%', height: 'auto' }}  // or height: 160 & objectFit: 'contain'
              />
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default GiftHeader;
